import Footer from "./Components/Footer";
import Header from "./Components/Header";

function About() {
  return (
    <>
      <Header />

      <main className="bg-background text-on-surface font-body-md antialiased">
        {/* Hero Section */}
        <section className="relative overflow-hidden pt-xl pb-xl bg-surface">
          <div className="absolute inset-0 hero-pattern"></div>
          <div className="max-w-container-max mx-auto px-gutter relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-xl items-center">
            <div className="text-left">
              <span className="inline-block px-4 py-1.5 rounded-lg bg-primary-container text-white font-label-md mb-6">
                Trusted Nationwide
              </span>
              <h1 className="font-headline-xl text-headline-lg-mobile md:text-headline-xl text-primary mb-6 leading-tight">
                Securing Homes, <br />
                <span className="text-secondary">Empowering Pros</span>
              </h1>
              <p className="font-body-lg text-body-lg text-on-surface-variant max-w-xl mb-10">
                The Locksmith USA is bridging the gap between property owners in distress and elite, verified locksmith professionals. Our platform ensures that security isn't just a service, but a national standard of trust.
              </p>
              <div className="flex flex-wrap gap-4">
                <button className="bg-primary text-white px-8 py-4 rounded-lg font-label-md shadow-xl hover:bg-primary/90 transition-all active:scale-95">
                  Our Mission
                </button>
                <button className="border-2 border-secondary text-secondary px-8 py-4 rounded-lg font-label-md hover:bg-secondary/5 transition-all active:scale-95">
                  View Transparency Report
                </button>
              </div>
            </div>
            <div className="relative group">
              <div className="absolute -inset-4 bg-secondary/5 rounded-xl blur-2xl group-hover:bg-secondary/10 transition-all duration-700"></div>
              <div className="relative rounded-xl overflow-hidden shadow-2xl border-4 border-white">
                <img
                  className="w-full h-[500px] object-cover scale-105 group-hover:scale-100 transition-transform duration-1000"
                  alt="A professional locksmith with a confident and friendly expression, wearing a navy blue uniform with a digital badge. He is working on a high-tech smart lock installation in a bright, modern residential setting with warm sunlight filtering through. The composition is clean and minimalist, utilizing a professional photography style with a shallow depth of field, emphasizing trust and technical expertise in a premium home security context."
                  src="https://lh3.googleusercontent.com/aida-public/AB6AXuD-gaV8CFKcSbGjl2RN_dOJBjm3Iz3L09T_m1_0eyf7Jl8lSsfThLpG9y_SRbQKLicfmMsbDT_9IDwwYx3miUrmNT6WUD9SIcBt48ZtfEGTTk0TS8QNLsxJxrQAE6fYYxwIyRb8jqyRdfDskO-WHMBTvk3G0Ta7m-8zpFZBMIrp_gYI-495q3KELliTWjKGzAzXDDUMoZ17XFE27J2aZbzqXSk24DNp5FJlBFFyBicLXwC8TnImnrhV2WeBPZiwPyjpQaxAs6j0IgU"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Our Story */}
        <section className="py-xl bg-surface-container-lowest">
          <div className="max-w-container-max mx-auto px-gutter">
            <div className="max-w-3xl mx-auto text-center mb-lg">
              <h2 className="font-headline-lg text-headline-lg text-primary mb-6">The Story of The Locksmith USA</h2>
              <div className="w-24 h-1.5 bg-secondary mx-auto mb-10"></div>
              <p className="font-body-lg text-body-lg text-on-surface-variant leading-relaxed">
                We were founded on a single realization: in moments of crisis—whether locked out of a home at midnight or needing an urgent security upgrade—people deserve more than just a phone number. They deserve a guarantee of safety.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-lg items-center mt-lg">
              <div className="order-2 md:order-1">
                <p className="font-body-md text-body-md text-on-surface-variant mb-6">
                  Traditional locksmith directories are often cluttered with unverified listings and predatory pricing. We saw an opportunity to redefine the industry by creating a curated marketplace where every professional undergoes rigorous screening before ever reaching your door.
                </p>
                <p className="font-body-md text-body-md text-on-surface-variant mb-6">
                  Since our inception, we've focused on technological innovation that makes finding help instant and transparent. Our commitment to safety is the foundation of everything we build, from our real-time tracking features to our comprehensive insurance coverage for every job.
                </p>
                <div className="flex items-center gap-8 mt-10">
                  <div>
                    <p className="text-4xl font-bold text-primary">15k+</p>
                    <p className="text-label-md text-on-surface-variant uppercase tracking-wider">Homes Secured</p>
                  </div>
                  <div className="w-px h-12 bg-outline-variant"></div>
                  <div>
                    <p className="text-4xl font-bold text-secondary">850+</p>
                    <p className="text-label-md text-on-surface-variant uppercase tracking-wider">Certified Pros</p>
                  </div>
                  <div className="w-px h-12 bg-outline-variant"></div>
                  <div>
                    <p className="text-4xl font-bold text-primary">4.9/5</p>
                    <p className="text-label-md text-on-surface-variant uppercase tracking-wider">User Rating</p>
                  </div>
                </div>
              </div>
              <div className="order-1 md:order-2 grid grid-cols-2 gap-4">
                <img
                  className="rounded-lg h-64 w-full object-cover shadow-lg"
                  alt="Close-up shot of a sophisticated security system interface on a tablet screen."
                  src="https://lh3.googleusercontent.com/aida-public/AB6AXuCz5p6ZWjVyz9eqQMwocZltfSy23WkLBmnA0An-6tYXGRrhb9ZjMxz2Fqv1gmt_pUNKZDo99wabO4JwdkoV7a1FLXRGwIsu_BTKqfKipGr-xGPXk5G49Nx4YDHBz9zMFb5Mc8iR_4GpeP1ASleM3T0R14XGNnGCrDZpsnXvrtMhmAhswuKspBwbLFaSfpkByI_9CoOW9mFJWaAfT7Y2VyqaTyufVztQX2QotLMyMXsVm99zoL0BBWO0okUqFuGSK_cE7vh6ZHu__Ig"
                />
                <img
                  className="rounded-lg h-64 w-full object-cover mt-8 shadow-lg"
                  alt="A professional team of security experts collaborating."
                  src="https://lh3.googleusercontent.com/aida-public/AB6AXuBRgJ8FrCKYFM8RdVDRZuKV5aP9nV6Q6SDaBB5nzYc2QWYZ03-BlEz9Pps7XjjyDgZN79qnMsyZ9rLGh8EDOZb99xffYHqG86_wXZMTPJXonTNrF6EsgCINNGuw3qVhxUyXWv-Zs94HuIviqPa6ny0W3LFUi0eO0PPMw3leFI6OIjRiW5k7J5jJyEq9SbKKQDZbeQSpwGr42BNTsVtZTdXdyDcbFmQLUcQGcDrAexVQLAgVzsn3DQ6FyEk-z6s7EGtzhV_axd-WndQ"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Core Values */}
        <section className="py-xl bg-surface-container-low">
          <div className="max-w-container-max mx-auto px-gutter">
            <div className="text-center mb-lg">
              <h2 className="font-headline-lg text-headline-lg text-primary mb-4">Guided by Integrity</h2>
              <p className="text-on-surface-variant font-body-lg">The principles that drive every connection we facilitate across the nation.</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-md">
              {/* Value 1 */}
              <div className="bg-white p-8 rounded-lg shadow-md border-b-4 border-primary hover:-translate-y-2 transition-transform duration-300">
                <div className="w-14 h-14 bg-primary/10 rounded-lg flex items-center justify-center mb-6">
                  <span className="material-symbols-outlined text-primary text-3xl" style={{ fontVariationSettings: "'FILL' 1" }}>
                    verified_user
                  </span>
                </div>
                <h3 className="font-headline-sm text-headline-md text-primary mb-4">Security First</h3>
                <p className="text-on-surface-variant font-body-md">Your safety is our non-negotiable priority. We implement multi-layered verification for every locksmith on our platform.</p>
              </div>
              {/* Value 2 */}
              <div className="bg-white p-8 rounded-lg shadow-md border-b-4 border-secondary hover:-translate-y-2 transition-transform duration-300">
                <div className="w-14 h-14 bg-secondary/10 rounded-lg flex items-center justify-center mb-6">
                  <span className="material-symbols-outlined text-secondary text-3xl" style={{ fontVariationSettings: "'FILL' 1" }}>
                    engineering
                  </span>
                </div>
                <h3 className="font-headline-sm text-headline-md text-primary mb-4">Verified Professionals</h3>
                <p className="text-on-surface-variant font-body-md">We only partner with the top 5% of applicants. Our pros are not just skilled; they are licensed, bonded, and vetted.</p>
              </div>
              {/* Value 3 */}
              <div className="bg-white p-8 rounded-lg shadow-md border-b-4 border-primary hover:-translate-y-2 transition-transform duration-300">
                <div className="w-14 h-14 bg-primary/10 rounded-lg flex items-center justify-center mb-6">
                  <span className="material-symbols-outlined text-primary text-3xl" style={{ fontVariationSettings: "'FILL' 1" }}>
                    payments
                  </span>
                </div>
                <h3 className="font-headline-sm text-headline-md text-primary mb-4">Transparent Pricing</h3>
                <p className="text-on-surface-variant font-body-md">No hidden fees, no bait-and-switch. You receive guaranteed price estimates before any work begins.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Trust & Safety Section */}
        <section className="py-xl bg-surface relative overflow-hidden">
          <div className="max-w-container-max mx-auto px-gutter grid grid-cols-1 lg:grid-cols-2 gap-xl items-center">
            <div className="relative">
              <div className="bg-primary-container rounded-lg p-12 text-white relative z-10 overflow-hidden shadow-2xl border-l-8 border-secondary">
                <div className="absolute top-0 right-0 p-8 opacity-10">
                  <span className="material-symbols-outlined text-[160px]" style={{ fontVariationSettings: "'FILL' 1" }}>
                    gpp_good
                  </span>
                </div>
                <h2 className="font-headline-lg text-headline-lg mb-8">The Gold Standard of Verification</h2>
                <ul className="space-y-6">
                  <li className="flex gap-4">
                    <div className="w-8 h-8 bg-secondary rounded-full flex items-center justify-center shrink-0">
                      <span className="material-symbols-outlined text-sm font-bold">check</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-lg mb-1">State Licensing</h4>
                      <p className="text-on-primary-container/90 text-sm">Mandatory verification of active locksmith licenses in compliance with regional regulations.</p>
                    </div>
                  </li>
                  <li className="flex gap-4">
                    <div className="w-8 h-8 bg-secondary rounded-full flex items-center justify-center shrink-0">
                      <span className="material-symbols-outlined text-sm font-bold">check</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-lg mb-1">Bonding &amp; Insurance</h4>
                      <p className="text-on-primary-container/90 text-sm">Every professional must maintain comprehensive liability insurance and bonding for your protection.</p>
                    </div>
                  </li>
                  <li className="flex gap-4">
                    <div className="w-8 h-8 bg-secondary rounded-full flex items-center justify-center shrink-0">
                      <span className="material-symbols-outlined text-sm font-bold">check</span>
                    </div>
                    <div>
                      <h4 className="font-bold text-lg mb-1">Identity &amp; Background Checks</h4>
                      <p className="text-on-primary-container/90 text-sm">Rigorous criminal background screenings through industry-leading third-party providers.</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div>
              <span className="font-label-md text-label-md text-secondary tracking-widest uppercase mb-4 block">Our Process</span>
              <h2 className="font-headline-lg text-headline-lg text-primary mb-6">Built on Absolute Trust</h2>
              <p className="text-body-lg text-on-surface-variant mb-8 leading-relaxed">
                We don't just "list" locksmiths; we curate a network of excellence. Our verification process is an ongoing commitment—we continuously monitor reviews, insurance status, and licensing validity to ensure the highest quality of service nationwide.
              </p>
              <div className="space-y-4">
                <div className="flex items-center gap-4 p-4 rounded-lg bg-white shadow-sm border border-surface-container-highest">
                  <span className="material-symbols-outlined text-secondary">policy</span>
                  <span className="font-semibold text-primary">100% Secure Transaction Guarantee</span>
                </div>
                <div className="flex items-center gap-4 p-4 rounded-lg bg-white shadow-sm border border-surface-container-highest">
                  <span className="material-symbols-outlined text-secondary">support_agent</span>
                  <span className="font-semibold text-primary">24/7 Dedicated Dispute Support</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-xl">
          <div className="max-w-container-max mx-auto px-gutter">
            <div className="bg-primary-container text-white rounded-lg p-12 text-center shadow-xl relative overflow-hidden group border-t-8 border-secondary">
              <div className="absolute -bottom-20 -right-20 w-80 h-80 bg-secondary/10 rounded-full blur-3xl group-hover:bg-secondary/20 transition-all duration-500"></div>
              <h2 className="font-headline-lg text-headline-lg mb-4">Ready to Secure Your Property?</h2>
              <p className="text-primary-fixed max-w-2xl mx-auto mb-10 text-body-lg">Whether you're in an emergency or planning a security upgrade, our verified professionals across the USA are ready to help.</p>
              <div className="flex justify-center gap-4">
                <button className="bg-secondary text-white px-10 py-4 rounded-lg font-label-md shadow-lg active:scale-95 transition-transform hover:bg-secondary/90">
                  Find a Locksmith Now
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default About;